export const invoiceTypeLabels: Record<string, { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }> = {
    GOA_INVOICE: { label: 'GOÄ', variant: 'default' },
    GOA_REFUND_INVOICE: { label: 'GOÄ Gutschrift', variant: 'destructive' },
    BUNDLE_INVOICE: { label: 'Bundle', variant: 'secondary' },
    BUNDLE_REFUND_INVOICE: { label: 'Bundle Gutschrift', variant: 'destructive' },
    GENERAL_INVOICE: { label: 'Allgemein', variant: 'outline' },
    GENERAL_REFUND_INVOICE: { label: 'Allgemein Gutschrift', variant: 'destructive' },
    GIFT_CARD_INVOICE: { label: 'Gutschein', variant: 'secondary' },
    GIFT_CARD_REFUND_INVOICE: { label: 'Gutschein Gutschrift', variant: 'destructive' },
    AUSFALL_INVOICE: { label: 'Ausfallentschädigung', variant: 'secondary' },
    AUSFALL_REFUND_INVOICE: { label: 'Ausfallentschädigung Gutschrift', variant: 'destructive' },
};

export const defaultInvoiceType = { label: 'Unbekannt', variant: 'outline' as const };
